import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { Main } from 'components/Main';
const AccountRaw = React.lazy(() => import(/* webpackChunkName: "AttorneyAccount" */ './Account'));
export const AttorneyAccount = () => (React.createElement(Page, { title: "Attorney Account", description: "Attorney account." },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AccountRaw, null)))));
